import React from "react";

function RecommendationViewLoading() {
  return (
    <div className="w-full max-w-[1500px] mx-auto pt-8 pb-10 px-5">
      {/* Main loading container */}
      <div className="bg-white shadow-sm rounded-lg p-6 mb-6 animate-pulse">
        {/* Top section with role info */}
        <div className="flex items-center mb-6">
          <div className="h-12 w-12 rounded-full bg-emerald-100 flex items-center justify-center mr-4">
            <svg className="h-6 w-6 text-emerald-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A11.97 11.97 0 0119.168 20.5H4.832A11.97 11.97 0 013 13.255a11.922 11.922 0 015.432-9.686C9.308 2.667 10.643 2 12 2c1.357 0 2.692.667 3.568 1.569A11.921 11.921 0 0121 13.255z" />
            </svg>
          </div>
          <div>
            <div className="h-7 bg-gray-200 rounded-md w-64 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded-md w-48"></div>
          </div>
        </div>

        {/* Stats section */}
        <div className="grid grid-cols-3 gap-4 mb-6">
          <div className="p-4 bg-gray-50 rounded-md">
            <div className="h-4 bg-gray-200 rounded-md w-20 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded-md w-12"></div>
          </div>
          <div className="p-4 bg-gray-50 rounded-md">
            <div className="h-4 bg-gray-200 rounded-md w-20 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded-md w-12"></div>
          </div>
          <div className="p-4 bg-gray-50 rounded-md">
            <div className="h-4 bg-gray-200 rounded-md w-20 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded-md w-12"></div>
          </div>
        </div>

        {/* Progress bar */}
        <div className="mb-8">
          <div className="h-4 bg-gray-200 rounded-md w-full mb-1"></div>
          <div className="flex justify-between items-center">
            <div className="h-3 bg-gray-200 rounded-md w-16"></div>
            <div className="h-3 bg-gray-200 rounded-md w-20"></div>
          </div>
        </div>

        {/* Loading message */}
        <div className="flex items-center justify-center mb-4">
          <div className="flex items-center space-x-4">
            <svg className="animate-spin h-6 w-6 text-[#02B491]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <div className="text-lg text-[#02B491] font-medium">Loading your tailored candidate recommendations...</div>
          </div>
        </div>
      </div>

      {/* Candidate grid skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array(6).fill().map((_, index) => (
          <div key={index} className="bg-white rounded-lg shadow-sm animate-pulse overflow-hidden">
            {/* Card header */}
            <div className="p-4 border-b">
              <div className="flex justify-between items-center">
                <div className="h-6 bg-gray-200 rounded-md w-32"></div>
                <div className="h-8 w-8 bg-gray-200 rounded-full"></div>
              </div>
            </div>
            
            {/* Card content */}
            <div className="p-4">
              <div className="h-5 bg-gray-200 rounded-md w-full mb-3"></div>
              <div className="h-4 bg-gray-200 rounded-md w-5/6 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded-md w-full mb-4"></div>
              
              {/* Tags */}
              <div className="flex flex-wrap gap-2 mb-4">
                <div className="h-6 bg-gray-200 rounded-full w-16"></div>
                <div className="h-6 bg-gray-200 rounded-full w-20"></div>
                <div className="h-6 bg-gray-200 rounded-full w-12"></div>
              </div>
              
              {/* Bottom section */}
              <div className="h-10 bg-gray-200 rounded-md w-full mt-4"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RecommendationViewLoading; 